import { render, staticRenderFns } from "./Cols-25-75.vue?vue&type=template&id=12a2abe1&scoped=true&"
import script from "./Cols-25-75.vue?vue&type=script&lang=js&"
export * from "./Cols-25-75.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a2abe1",
  null
  
)

export default component.exports